const MEDIA_ITEMS = [
  {
    title: '《鬼灭之刃 柱训练篇》PV',
    desc: '最终决战前的最后特训，全员集结的震撼预告',
    image: 'https://readdy.ai/api/search-image?query=Epic%20anime%20training%20montage%20scene%20with%20multiple%20characters%20practicing%20sword%20techniques%2C%20warm%20sunset%20lighting%20over%20traditional%20Japanese%20dojo%2C%20dynamic%20poses%2C%20cinematic%20anime%20composition%2C%20golden%20hour%20atmosphere&width=640&height=400&seq=media-01&orientation=landscape',
    duration: '02:15',
  },
  {
    title: '《咒术回战》名场面回顾',
    desc: '五条悟领域展开——无量空处，年度最燃战斗',
    image: 'https://readdy.ai/api/search-image?query=Intense%20anime%20supernatural%20battle%20climax%20with%20bright%20energy%20explosion%2C%20character%20with%20white%20hair%20and%20blindfold%2C%20dramatic%20blue%20and%20white%20lighting%2C%20epic%20scale%2C%20cinematic%20anime%20art%20style&width=640&height=400&seq=media-02&orientation=landscape',
    duration: '03:42',
  },
  {
    title: '《葬送的芙莉莲》MAD',
    desc: '千年魔法使的旅程，治愈与感动的完美剪辑',
    image: 'https://readdy.ai/api/search-image?query=Emotional%20anime%20scene%20with%20elf%20character%20looking%20at%20starlit%20sky%20in%20peaceful%20meadow%2C%20nostalgic%20atmosphere%2C%20soft%20blue%20and%20silver%20lighting%2C%20gentle%20breeze%2C%20beautiful%20anime%20art%20style&width=640&height=400&seq=media-03&orientation=landscape',
    duration: '04:18',
  },
  {
    title: '七月新番导视合集',
    desc: '本季度最值得期待的动画作品全预览',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20collage%20style%20composition%20with%20multiple%20character%20silhouettes%20from%20different%20genres%2C%20vibrant%20summer%20atmosphere%2C%20bright%20and%20energetic%20color%20palette%2C%20modern%20anime%20promotional%20art%20style&width=640&height=400&seq=media-04&orientation=landscape',
    duration: '08:30',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">精彩片段</h2>
          <p className="text-sm text-foreground-500">热门动漫精选片段与预告合集</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {MEDIA_ITEMS.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-accent-200 transition-all duration-300"
            >
              <div className="relative aspect-video overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-foreground-950/20 group-hover:bg-foreground-950/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-2xl text-primary-500 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-foreground-950/70 rounded text-[11px] text-background-50">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-heading text-foreground-950 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}